import client from '../client'

export const getMyConversationsKey = `${process.env.NEXT_PUBLIC_CHAT_DOMAIN}/api/Chat/GetMyConversations`

export async function getMyConversations(returnVerifiedDealer) {
  const params = new URLSearchParams({
    returnVerifiedDealer: returnVerifiedDealer,
  })
  return client(`${getMyConversationsKey}?${params}`)
}
